import GreenPetriDish from '../assets/images/petri-dish-1.png';
import PinkPetriDish from '../assets/images/petri-dish-2.png';
import BluePetriDish from '../assets/images/petri-dish-3.png';
import TealPetriDish from '../assets/images/petri-dish-4.png';

export const petriCombos = [
    {
        image: GreenPetriDish,
        colour: '#009F4D',
        secondaryColour: '#93D500'
    },
    {
        image: BluePetriDish,
        colour: '#410099',
        secondaryColour: '#6786B8'
    },
    {
        image: PinkPetriDish,
        colour: '#AB0033',
        secondaryColour: '#EC7700'
    },
    {
        image: TealPetriDish,
        colour: '#006937',
        secondaryColour: '#57B6B2'
    }
];

export const getRandomCombination = () => {
    const rand = Math.floor( Math.random() * petriCombos.length  );
    return petriCombos[ rand ];
};


// WEBPACK FOOTER //
// ./src/config/petri-combinations.js